import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/leave";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export type leave_type_approve = {
  leave_approve_first?:number | null
  leave_approve_first_comment?: string;
  leave_approve_second?: number | null
  leave_approve_second_comment?: string;
  leave_approve_third?: number | null
  leave_approve_third_comment?: string;
  leave_status: string;
  modified_id?: number;
  modified_date: string;
  id_leave_period: number | null;
  emp_before_start_work?: string;
  assignment_international_type_2?: string;
  perform_type_2_work?: string;
  does_university_plans?: string;
  beneficial_thailand?: string;
}

export class OnlineLeaveSubmissionApi extends BaseAPI {
  static getAllRequestLeaveSubmission(query: listType): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static getRequestLeaveSubmissionByEmployee(query: listType): Promise<any> {
    return this.api.get(`${path}/list-by-employee`, {
      params: { ...query },
    });
  }

  static getSingleRequestLeaveSubmission(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/detail`);
  }

  static getSingleRequestLeaveSubmissionForPrint(
    id: number,
    token: string
  ): Promise<any> {
    return this.api.get(`${path}/${id}/detail`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  static updateRequestLeaveSubmission(
    id: number,
    body: FormData
  ): Promise<any> {
    return this.api.patch(`${path}/${id}/update`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static createRequestLeaveSubmission(body: FormData): Promise<any> {
    return this.api.post(`${path}/create`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static deleteRequestLeaveSubmission(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}/delete`);
  }

  static getHolidayByEmployeeId(id: number): Promise<any> {
    return this.api.get(`${path}/employee/${id}/list`);
  }

  static approveLeaveRequestWithId(id: number, body: leave_type_approve): Promise<any> {
    return this.api.patch(`${path}/${id}/approve`, body);
  }

  static getApproveFirst(): Promise<any> {
    return this.api.get(`${path}/head/approve`);
  }

  static getRequestForApprove(query: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/approve`, {
      params: { ...query },
    });
  }

  static GetFileByIdLeaveFile(query: listType, id_leave: number): Promise<any> {
    return this.api.get(`${path}/file/${id_leave}/download`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static GetDownloadFile(query?: listType): Promise<any> {
    return this.api.get(`${path}/file/download/all`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static getLeaveForExportApprove(
    id: number,
    token: string,
    form_code: string
  ): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id}/pdf/${token}?form=${form_code}`, {
      responseType: "arraybuffer",
    });
  }
}
